// SR-CUSTOM: Design your own builder. Markup + data live in sections/design-your-own.liquid.
// Tracking: every event goes out as dyo_<name> to Shopify customer events and the Google tag,
// and as DYO<Name> custom events to the Meta pixel, with the design (material, size, button) attached.
// Hook mode (data.kind 'hook', 31 Oct 2026): no Size option, so the third choice is Single or Pack of 3 (size ids
// 'single' / 'pack'); events carry kind: 'hook'. Products tagged Coming Soon can be designed but not added.
document.querySelectorAll('[data-dyo]').forEach(function (root) {
  var data = JSON.parse(root.querySelector('[data-dyo-data]').textContent);
  var HOOK = data.kind === 'hook';
  var STORE = data.store || 'sr-dyo';
  var DEF = data.def || { mat: 'oak', btn: 'brushed-steel' };
  var MAT_ORDER = ['white-marble', 'latte-marble', 'red-marble', 'green-marble', 'oak', 'walnut', 'brass', 'aged-bronze', 'brushed-copper', 'brushed-steel', 'gunmetal', 'matte-black'];
  var GROUPS = ['Marble', 'Timber', 'Metal'];
  var FINISH_ORDER = ['Brass', 'Aged Bronze', 'Brushed Copper', 'Brushed Steel', 'Gunmetal', 'Matte Black', 'Matte White'];
  var MAT_COLOUR = { 'white-marble': '#E4E0D8', 'latte-marble': '#C9B394', 'red-marble': '#6B2B27', 'green-marble': '#2E3A31', 'oak': '#C8A272', 'walnut': '#5E4130', 'brass': '#B8955A', 'aged-bronze': '#6A4F38', 'brushed-copper': '#A9694B', 'brushed-steel': '#A9A9A6', 'gunmetal': '#4B4C4F', 'matte-black': '#1F1D1B' };

  function slug(t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }
  function sizeId(label) { if (HOOK) return /pack/i.test(label) ? 'pack' : 'single'; return /knob/i.test(label) ? 'knob' : ((String(label).match(/\d+/) || [''])[0]); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function money(c) { return '$' + (Math.max(0, c) / 100).toFixed(2); }

  // Build the model from Shopify data
  var mats = data.products.map(function (p) {
    var id = p.id || p.handle.replace(/-ensemble-(handle|hook)$/, '');
    var sizes = {}, finishes = {}, byKey = {};
    p.variants.forEach(function (v) {
      var z = sizeId(v.size), f = slug(v.finish);
      sizes[z] = v.size; finishes[f] = v.finish; byKey[z + '|' + f] = v;
    });
    return { id: id, soon: !!p.soon, name: p.title.replace(/\s*Ensemble (Handle|Hook)$/i, ''), group: p.group, url: p.url, specs: p.specs, sheet: p.sheet, rating: +p.rating || 0, reviews: +p.reviews || 0, sizes: sizes, finishes: finishes, v: byKey };
  }).sort(function (a, b) {
    var ia = MAT_ORDER.indexOf(a.id), ib = MAT_ORDER.indexOf(b.id);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
  if (!mats.length) return;
  var SIZE_ORDER = HOOK ? ['single', 'pack'] : ['knob', '128', '160', '192', '224'];
  var allFinishes = [];
  FINISH_ORDER.forEach(function (n) { allFinishes.push({ id: slug(n), name: n }); });

  // Reserve the rating line only when at least one material shows stars, so the card does not jump between materials
  function showsRating(m) { return m.reviews >= (data.minReviews || 3) && m.rating > 0; }
  if (mats.some(showsRating)) root.classList.add('has-ratings');

  function findMat(id) { return mats.filter(function (m) { return m.id === id; })[0]; }
  function overall(mat, z) { return z === 'knob' ? 40 : (+z + 20 + (mat.group === 'Marble' ? 10 : 0)); }
  function sizeName(z) { return z === 'single' ? 'Single' : z === 'pack' ? 'Pack of 3' : z === 'knob' ? 'Knob' : z + 'mm'; }
  function variant(mat, z, f) { return mat.v[z + '|' + f]; }
  function priceHtml(v) {
    if (!v) return '—';
    if (data.trade) return esc(v.trade) + '<span class="dyo-gst">inc GST</span><span class="dyo-rrp">RRP <s>' + esc(v.price) + '</s></span><span class="dyo-trade">Trade pricing</span>';
    return esc(v.price) + '<span class="dyo-gst">inc GST</span>';
  }
  function priceText(v) { return v ? (data.trade ? v.trade : v.price) : '—'; }
  function priceCents(v) { return v ? (data.trade ? v.tradeCents : v.cents) : 0; }

  // Stock. Every finish of a material and size shares one handle body, so anything already in the cart in that
  // material and size comes off what can still be bought (the same rule as snippets/sr-stock-remaining.liquid).
  // Untracked variants, or ones set to keep selling, have no limit.
  var lastCart = null;
  function inCartSameBody(mat, z) {
    if (!lastCart) return 0;
    var ids = {};
    Object.keys(mat.v).forEach(function (k) { if (k.split('|')[0] === z) ids[mat.v[k].id] = true; });
    return lastCart.items.reduce(function (a, i) { return a + (ids[i.variant_id] ? i.quantity : 0); }, 0);
  }
  function remaining(mat, z, f) {
    var v = variant(mat, z, f);
    if (!v) return 0;
    if (mat.soon) return 0;
    if (!v.tracked) return Infinity;
    return Math.max(0, v.stock - inCartSameBody(mat, z));
  }

  // State: URL params > remembered design > defaults
  // First visit starts on an oak knob with a brushed steel button
  var state = { mat: findMat(DEF.mat) ? DEF.mat : mats[0].id, size: HOOK ? 'single' : 'knob', btn: DEF.btn, qty: 1 };
  var source = 'default';
  try { var saved = JSON.parse(localStorage.getItem(STORE) || 'null'); if (saved) { state.mat = saved.mat || state.mat; state.size = saved.size || state.size; state.btn = saved.btn || state.btn; source = 'remembered'; } } catch (e) {}
  var qs = new URLSearchParams(location.search);
  if (qs.get('material')) { state.mat = qs.get('material').replace(/-ensemble-(handle|hook)$/, ''); source = 'link'; }
  if (qs.get('size')) state.size = sizeId(qs.get('size'));
  if (qs.get('button')) state.btn = slug(qs.get('button'));
  if (qs.get('utm_source') === 'share') source = 'shared';
  if (!findMat(state.mat)) state.mat = mats[0].id;

  function normalise() {
    var mat = findMat(state.mat);
    if (!mat.sizes[state.size]) {
      var avail = SIZE_ORDER.filter(function (z) { return mat.sizes[z]; });
      state.size = HOOK ? avail[0] : avail.indexOf('192') >= 0 && state.size === '224' ? '192' : (avail[1] || avail[0]);
    }
    if (!mat.finishes[state.btn]) state.btn = Object.keys(mat.finishes)[0];
  }
  function remember() {
    try { localStorage.setItem(STORE, JSON.stringify({ mat: state.mat, size: state.size, btn: state.btn })); } catch (e) {}
    try { var u = new URL(location.href); u.searchParams.set('material', state.mat); u.searchParams.set('size', state.size); u.searchParams.set('button', state.btn); history.replaceState(null, '', u.toString()); } catch (e) {}
  }

  // Tracking
  function design() { var d = { material: state.mat, size: state.size, button: state.btn, design: state.mat + '_' + state.size + '_' + state.btn }; if (HOOK) { d.kind = 'hook'; d.design = 'hook_' + d.design; } return d; }
  var META = { view: 'DYOView', choose: 'DYOChoose', add_to_cart: 'DYOAddToCart', quick_add: 'DYOQuickAdd', specs: 'DYOSpecs', zoom: 'DYOZoom', share: 'DYOShare', shared_open: 'DYOSharedOpen', shortlist_add: 'DYOShortlistAdd', shortlist_remove: 'DYOShortlistRemove' };
  function track(name, extra) {
    var p = design();
    Object.keys(extra || {}).forEach(function (k) { p[k] = extra[k]; });
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dyo_' + name, p); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'dyo_' + name, p); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', META[name] || 'DYO' + name, p); } catch (e) {}
  }

  var $ = function (sel) { return root.querySelector(sel); };
  // Every [data-sum] shows the same choice (only the unused "bar" banner style still has them)
  function setAll(sel, text) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; }); }

  // Phones and tablets: the photo sticks just under the sticky header bar while choosing. The section CSS reads
  // --dyo-top. The visible bar is the <header> inside the sticky header section (the section itself is taller).
  // --dyo-top is where the bar will end once it finishes sliding (the theme hides the announcement toolbar after
  // 300px with sticky-header-show, and the whole bar with sticky-header-hide), so the photo slides with it.
  var headerSection = document.querySelector('.shopify-section-group-header-group[id*="header"]');
  var headerBar = headerSection && (headerSection.querySelector('header') || headerSection);
  var toolBar = document.getElementById('ToolBar');
  var docEl = document.documentElement, topQueued = false;
  function placeTop() {
    topQueued = false;
    var top = 0;
    if (headerBar && getComputedStyle(headerSection).position === 'sticky' && !docEl.classList.contains('sticky-header-hide')) {
      top = headerSection.getBoundingClientRect().top + headerBar.offsetHeight;
      if (docEl.classList.contains('sticky-header-show') && toolBar) top -= toolBar.offsetHeight;
      top = Math.max(0, Math.round(top));
    }
    root.style.setProperty('--dyo-top', top + 'px');
  }
  function queueTop() { if (!topQueued) { topQueued = true; requestAnimationFrame(placeTop); } }
  // While choosing on phones and tablets, the site header slides away on scroll down (once the banner has gone)
  // and comes back on any scroll up, so the photo and the steps get the room (David, 19 Oct)
  var lastY = window.scrollY;
  function headerAway() {
    var y = window.scrollY, dy = y - lastY;
    if (Math.abs(dy) < 6) return;
    lastY = y;
    var banner = $('.dyo-banner');
    var hide = dy > 0 && window.innerWidth < 990 && !!headerBar && !!banner && banner.getBoundingClientRect().bottom < headerBar.offsetHeight;
    if (hide === docEl.classList.contains('sticky-header-hide')) return;
    docEl.classList.toggle('sticky-header-hide', hide);
    placeTop();
  }
  window.addEventListener('scroll', function () { headerAway(); queueTop(); }, { passive: true });

  // Safari on iOS 26 paints a solid strip over the bottom of pages that do not opt into viewport-fit=cover, and it
  // hid the fixed Add to cart bar while scrolling. Opt in on this page in portrait; the bar and the pop-ups already pad
  // themselves with env(safe-area-inset-bottom). Landscape keeps the theme's default so nothing sits under the notch.
  var vpMeta = document.querySelector('meta[name="viewport"]');
  if (vpMeta && window.matchMedia) {
    var vpBase = (vpMeta.getAttribute('content') || '').replace(/,\s*viewport-fit=cover/g, '');
    var portrait = window.matchMedia('(orientation: portrait)');
    var fitCover = function () { vpMeta.setAttribute('content', vpBase + (portrait.matches ? ', viewport-fit=cover' : '')); };
    fitCover();
    if (portrait.addEventListener) portrait.addEventListener('change', fitCover);
  }
  window.addEventListener('resize', queueTop);
  if (headerSection) headerSection.addEventListener('transitionend', queueTop);

  // Swatch labels sit under a group heading, so marbles drop the word "Marble" ("Latte", not "Latte Marble")
  function tileName(m) { return m.group === 'Marble' ? m.name.replace(/\s*Marble$/i, '') : m.name; }

  function renderMaterials() {
    var html = '';
    GROUPS.forEach(function (g) {
      var list = mats.filter(function (m) { return m.group === g; });
      if (!list.length) return;
      html += '<div class="dyo-group"><div class="dyo-group-head"><b>' + esc(g) + '</b></div><div class="dyo-tiles" role="group" aria-label="' + esc(g) + '">';
      list.forEach(function (m) {
        var sw = data.swatches[m.id];
        html += '<button type="button" class="dyo-tile" data-mat="' + esc(m.id) + '" aria-pressed="' + (m.id === state.mat) + '" aria-label="' + esc(m.name) + '">' +
          (sw ? '<img src="' + esc(sw) + '" alt="" width="60" height="60">' : '<img alt="" width="60" height="60" style="background:' + (MAT_COLOUR[m.id] || '#ccc') + '">') +
          '<span>' + esc(tileName(m)) + '</span></button>';
      });
      html += '</div></div>';
    });
    // Phones show Material as one sideways-scrolling row (section CSS). Re-rendering would jump it back to the start,
    // so keep where it was scrolled to, and bring the chosen swatch into view if it is off the edge.
    var box = $('[data-materials]'), was = box.firstElementChild ? box.firstElementChild.scrollLeft : 0;
    box.innerHTML = '<div style="display:flex;flex-direction:column;gap:22px;">' + html + '</div>';
    var row = box.firstElementChild;
    if (row.scrollWidth > row.clientWidth + 1) {
      row.scrollLeft = was;
      var sel = row.querySelector('[aria-pressed="true"]');
      if (sel) {
        var r = sel.getBoundingClientRect(), b = row.getBoundingClientRect();
        if (r.left < b.left + 16 || r.right > b.right - 16) row.scrollLeft += (r.left - b.left) - (b.width - r.width) / 2;
      }
    }
    moreState();
  }

  // Phones: an arrow on the Material heading (and a soft fade at the row's edge) shows there are more swatches
  // to the side. Tapping it scrolls on; at the end it turns round and goes back to the start (David, 19 Oct).
  var more = $('[data-more]');
  function moreState() {
    var row = $('[data-materials] > div');
    if (!more || !row) return;
    var max = row.scrollWidth - row.clientWidth, x = row.scrollLeft, scrolls = max > 1, atEnd = x >= max - 4;
    more.hidden = !scrolls;
    more.classList.toggle('is-back', scrolls && atEnd);
    more.setAttribute('aria-label', scrolls && atEnd ? 'Back to the first materials' : 'See more materials');
    row.classList.toggle('more-right', scrolls && !atEnd);
    row.classList.toggle('more-left', scrolls && x > 4);
  }
  if (more) {
    more.addEventListener('click', function () {
      var row = $('[data-materials] > div');
      if (!row) return;
      var max = row.scrollWidth - row.clientWidth, atEnd = row.scrollLeft >= max - 4;
      // Jump about two-thirds of a screen; if that would stop just short of the end, go all the way
      var next = row.scrollLeft + Math.round(row.clientWidth * 0.7);
      if (next > max - row.clientWidth * 0.3) next = max;
      row.scrollTo({ left: atEnd ? 0 : next, behavior: 'smooth' });
    });
    // Scroll events do not bubble, so listen while capturing (the row itself is rebuilt on every render)
    $('[data-materials]').addEventListener('scroll', moreState, true);
    window.addEventListener('resize', moreState);
  }

  function renderSizes() {
    var mat = findMat(state.mat), html = '';
    SIZE_ORDER.forEach(function (z) {
      var has = !!mat.sizes[z];
      var v = has ? variant(mat, z, state.btn) : null;
      var out = has && !mat.soon && v && v.tracked && v.stock <= 0;
      if (HOOK) {
        if (!has) return;
        var single = variant(mat, 'single', state.btn), save = z === 'pack' && single && v ? priceCents(single) * 3 - priceCents(v) : 0;
        var dots = new Array(z === 'pack' ? 4 : 2).join('<i class="knob" style="background:' + (MAT_COLOUR[mat.id] || '#999') + '"></i>');
        var hsub = out ? 'Out of stock in this finish' : (z === 'pack' ? (save > 0 ? 'Save ' + money(save) : '3 hooks') : '1 hook');
        html += '<button type="button" class="dyo-size' + (out ? ' is-out' : '') + '" data-size="' + z + '" aria-pressed="' + (z === state.size) + '">' +
          '<span class="dyo-scale" aria-hidden="true">' + dots + '</span>' +
          '<span class="dyo-size-txt"><b>' + sizeName(z) + '</b><small' + (save > 0 && !out ? ' class="save"' : '') + '>' + hsub + '</small></span>' +
          '<span class="dyo-size-price">' + esc(priceText(v)) + '</span></button>';
        return;
      }
      var ov = overall(mat, z);
      var bar = z === 'knob' ? '<i class="knob" style="background:' + (MAT_COLOUR[mat.id] || '#999') + '"></i>' : '<i style="width:' + Math.round(ov / 254 * 100) + '%;background:' + (MAT_COLOUR[mat.id] || '#999') + '"></i>';
      var sub = !has ? 'Not available in ' + esc(mat.group.toLowerCase()) : (out ? 'Out of stock in this finish' : (z === 'knob' ? '40mm diameter' : ov + 'mm overall'));
      html += '<button type="button" class="dyo-size' + (out ? ' is-out' : '') + '" data-size="' + z + '" aria-pressed="' + (z === state.size) + '"' + (has ? '' : ' disabled') + ' title="' + sub + '">' +
        '<span class="dyo-scale" aria-hidden="true">' + bar + '</span>' +
        '<span class="dyo-size-txt"><b>' + sizeName(z) + '</b><small>' + sub + '</small></span>' +
        '<span class="dyo-size-price">' + (has ? esc(priceText(v)) : '') + '</span></button>';
    });
    $('[data-sizes]').innerHTML = html;
  }

  function renderButtons() {
    var mat = findMat(state.mat), html = '';
    allFinishes.forEach(function (f) {
      if (!mat.finishes[f.id]) return;
      var sw = data.swatches[f.id];
      html += '<button type="button" class="dyo-tile" data-btn="' + f.id + '" aria-pressed="' + (f.id === state.btn) + '">' +
        (sw ? '<img src="' + esc(sw) + '" alt="" width="60" height="60" loading="lazy">' : '') + '<span>' + esc(f.name) + '</span></button>';
    });
    $('[data-buttons]').innerHTML = html;
  }

  function titleFor(mat) { if (HOOK) return mat.name + ' Ensemble Hook' + (state.size === 'pack' ? ' — Pack of 3' : ''); return mat.name + ' Ensemble ' + (state.size === 'knob' ? 'Knob' : 'Handle'); }
  // Full description (zoom caption, spec card, photo alt text)
  function specFor(mat) { if (HOOK) return (state.size === 'pack' ? 'Pack of 3 · ' : '') + '40mm hook · ' + (mat.finishes[state.btn] || '') + ' button'; return (state.size === 'knob' ? 'Knob, 40mm' : state.size + 'mm centres, ' + overall(mat, state.size) + 'mm overall') + ' · ' + (mat.finishes[state.btn] || '') + ' button'; }
  // Short line on the design card / phone summary: size and button only (overall length is in the spec card)
  function cardSpec(mat) { if (HOOK) return (mat.finishes[state.btn] || '') + ' button'; return (state.size === 'knob' ? '40mm knob' : state.size + 'mm centres') + ' · ' + (mat.finishes[state.btn] || '') + ' button'; }

  // Stock line under the price, worded and coloured like the product page inventory block,
  // but only when it matters: low stock, all in cart, or out of stock. Plenty in stock shows nothing.
  function renderStock() {
    var mat = findMat(state.mat), v = variant(mat, state.size, state.btn), st = '', label = '';
    if (mat.soon) {}
    else if (v && v.tracked) {
      var left = remaining(mat, state.size, state.btn);
      if (v.stock <= 0) { st = 'red'; label = 'Out of stock'; }
      else if (left <= 0) { st = 'amber'; label = 'All available stock is in your cart'; }
      else if (left <= (data.lowStock || 7)) { st = 'amber'; label = 'Only ' + left + ' available'; }
    } else if (v && !v.available) { st = 'red'; label = 'Out of stock'; }
    $('[data-stock]').setAttribute('data-state', st);
    $('[data-stock-text]').textContent = label;
  }

  function renderPreview() {
    var mat = findMat(state.mat), v = variant(mat, state.size, state.btn);
    var fname = mat.finishes[state.btn] || '';
    var title = titleFor(mat), spec = specFor(mat);
    var img = $('[data-photo]');
    if (v && v.img && img.getAttribute('src') !== v.img) img.src = v.img;
    img.alt = title + ', ' + spec;
    var thumb = $('[data-buy-thumb]');
    if (thumb && v && v.thumb && thumb.getAttribute('src') !== v.thumb) thumb.src = v.thumb;
    $('[data-name]').textContent = title;
    $('[data-spec]').textContent = cardSpec(mat);
    var r = $('[data-rating]');
    if (showsRating(mat)) {
      var full = Math.round(mat.rating);
      r.innerHTML = '<b aria-hidden="true">' + new Array(full + 1).join('★') + new Array(6 - full).join('☆') + '</b>' + mat.rating.toFixed(1) + ' · ' + mat.reviews + ' reviews';
      r.setAttribute('aria-label', 'Rated ' + mat.rating.toFixed(1) + ' out of 5 from ' + mat.reviews + ' reviews');
      r.hidden = false;
    } else { r.hidden = true; }
    $('[data-price]').innerHTML = priceHtml(v);
    renderStock();
    var left = remaining(mat, state.size, state.btn);
    if (state.qty > left) state.qty = Math.max(1, left);
    $('[data-price-short]').textContent = priceText(v);
    $('[data-short]').textContent = mat.name + ' · ' + sizeName(state.size) + ' · ' + fname;
    setAll('[data-sum="mat"]', mat.name);
    setAll('[data-sum="size"]', HOOK ? sizeName(state.size) : state.size === 'knob' ? 'Knob · 40mm' : state.size + 'mm centres');
    setAll('[data-sum="btn"]', fname);
    $('[data-qty-out]').textContent = state.qty;
    var plus = $('[data-qty="1"]'); plus.disabled = state.qty >= left;
    var add = $('[data-add]');
    var canBuy = !!(v && v.available) && left > 0;
    add.disabled = !canBuy;
    add.textContent = mat.soon ? (data.soonLabel || 'Coming soon') : canBuy ? 'Add to cart' : (v && v.tracked && v.stock > 0 ? 'Limit reached' : 'Out of stock');
    heartState();
  }

  function renderAll() { normalise(); renderMaterials(); renderSizes(); renderButtons(); renderPreview(); remember(); }

  // Shortlist heart beside Add to cart. The list is kept by assets/sr-shortlist.js (window.SRShortlist), which also runs the
  // header heart and the shortlist drawer. The door the design was seen on (Door Visualiser) is saved with it (David, 19 Oct).
  var heart = $('[data-heart]'), saved = $('[data-saved]'), savedTimer;
  function heartState() {
    if (!heart) return;
    var on = !!(window.SRShortlist && SRShortlist.has(state.mat, state.size, state.btn));
    heart.setAttribute('aria-pressed', String(on));
    heart.setAttribute('aria-label', on ? 'Remove from shortlist' : 'Save to shortlist');
  }
  if (heart) {
    heart.addEventListener('click', function () {
      if (!window.SRShortlist) return;
      var on = SRShortlist.toggle({ m: state.mat, z: state.size, b: state.btn, d: root.getAttribute('data-door') || '', dn: root.getAttribute('data-door-name') || '' });
      heartState();
      track(on ? 'shortlist_add' : 'shortlist_remove');
      if (saved) {
        $('[data-saved-text]').textContent = on ? 'Saved to your shortlist' : 'Removed from your shortlist';
        saved.hidden = false;
        clearTimeout(savedTimer); savedTimer = setTimeout(function () { saved.hidden = true; }, 4000);
      }
    });
    document.addEventListener('sr-shortlist:change', heartState);
    var savedView = $('[data-saved-view]');
    if (savedView) savedView.addEventListener('click', function () { saved.hidden = true; if (window.SRShortlist) SRShortlist.open(); });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mat],[data-size],[data-btn],[data-qty]');
    if (!t || !root.contains(t)) return;
    var step;
    if (t.hasAttribute('data-mat')) { state.mat = t.getAttribute('data-mat'); step = 'material'; }
    else if (t.hasAttribute('data-size')) { if (t.disabled) return; state.size = t.getAttribute('data-size'); step = 'size'; }
    else if (t.hasAttribute('data-btn')) { state.btn = t.getAttribute('data-btn'); step = 'button'; }
    else if (t.hasAttribute('data-qty') && !t.closest('[data-quick]')) {
      var mat = findMat(state.mat), left = remaining(mat, state.size, state.btn), err = $('[data-error]');
      var next = Math.max(1, state.qty + (+t.getAttribute('data-qty')));
      if (next > left) { err.textContent = 'Only ' + left + ' available in this design.'; err.hidden = false; return; }
      err.hidden = true; state.qty = next;
      $('[data-qty-out]').textContent = state.qty; $('[data-qty="1"]').disabled = state.qty >= left;
      return;
    }
    else return;
    $('[data-error]').hidden = true;
    var keepFocus = t.getAttribute('data-mat') ? '[data-mat="' + state.mat + '"]' : t.getAttribute('data-size') ? '[data-size="' + state.size + '"]' : '[data-btn="' + state.btn + '"]';
    renderAll();
    track('choose', { step: step });
    var f = root.querySelector(keepFocus); if (f) f.focus({ preventScroll: true });
  });

  // Cart helpers
  function addItems(items) {
    return fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (j) { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { productId: '' } })); return refreshCart().then(function () { return j; }); });
  }
  var handles = {};
  data.products.forEach(function (p) { handles[p.handle] = true; if (p.pack) handles[p.pack] = true; });
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      lastCart = cart;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      document.querySelectorAll('.cart-button').forEach(function (b) { b.classList.toggle('has-count-visible', cart.item_count > 0); });
      renderPreview();
      var lines = cart.items.filter(function (i) { return handles[i.handle]; });
      var box = $('[data-incart]');
      if (!lines.length) { box.hidden = true; return; }
      var n = lines.reduce(function (a, i) { return a + i.quantity; }, 0);
      $('[data-incart-count]').textContent = 'In your cart · ' + n + (n === 1 ? ' piece' : ' pieces');
      $('[data-incart-lines]').innerHTML = lines.map(function (i) {
        var img = i.image ? i.image + (i.image.indexOf('?') >= 0 ? '&' : '?') + 'width=120' : '';
        return '<div class="dyo-line">' + (img ? '<img src="' + esc(img) + '" alt="" width="40" height="40" loading="lazy">' : '') + '<span>' + esc(i.product_title.replace(/\s*Ensemble (Handle|Hook)\b/i, '')) + ' · ' + esc(i.variant_title || '') + '</span><em>× ' + i.quantity + '</em></div>';
      }).join('');
      box.hidden = false;
    }).catch(function () {});
  }

  // Quick add (other sizes, same finish)
  // The size just added stays editable: its stepper starts at the quantity in the cart and changes adjust that cart line.
  // Each row is capped at what can still be bought.
  var quick = {}, added = null;
  function quickMax(mat, z) {
    var left = remaining(mat, z, state.btn);
    return (added && z === added.z ? added.qty : 0) + left;
  }
  function quickCounts() {
    var mat = findMat(state.mat), others = 0, delta = 0, value = 0;
    Object.keys(quick).forEach(function (z) {
      var v = variant(mat, z, state.btn);
      if (added && z === added.z) { delta = quick[z] - added.qty; value += delta * priceCents(v); }
      else { others += quick[z]; value += quick[z] * priceCents(v); }
    });
    return { others: others, delta: delta, value: value };
  }
  function renderShip(extra) {
    var box = $('[data-ship]');
    if (!data.ship || !data.ship.on || !lastCart) { box.hidden = true; return; }
    var total = lastCart.total_price + (extra || 0), min = data.ship.min;
    $('[data-ship-text]').textContent = total >= min ? 'Your order ships free within Australia.' : 'You’re ' + money(min - total) + ' away from free shipping within Australia.';
    $('[data-ship-bar]').style.width = Math.min(100, Math.round(total / min * 100)) + '%';
    box.hidden = false;
  }
  function renderQuick() {
    var mat = findMat(state.mat), html = '';
    SIZE_ORDER.forEach(function (z) {
      if (!mat.sizes[z]) return;
      var v = variant(mat, z, state.btn);
      var max = quickMax(mat, z);
      var isAdded = added && z === added.z;
      var off = !(v && v.available) || max <= 0;
      var n = quick[z] || 0;
      var sub = isAdded ? 'In your cart' : (off ? 'Out of stock' : (HOOK ? (z === 'pack' ? '3 hooks' : '1 hook') : z === 'knob' ? '40mm diameter' : overall(mat, z) + 'mm overall'));
      if (!off && max !== Infinity && max - (isAdded ? added.qty : 0) <= (data.lowStock || 7)) sub += ' · only ' + (max - (isAdded ? added.qty : 0)) + ' more available';
      html += '<div class="dyo-qrow' + (off ? ' is-off' : '') + '">' + (v && v.thumb ? '<img src="' + esc(v.thumb) + '" alt="" width="52" height="52" loading="lazy">' : '<img alt="" width="52" height="52">') +
        '<span class="t"><b>' + (HOOK ? sizeName(z) : z === 'knob' ? 'Knob' : z + 'mm centres') + '</b><small>' + esc(sub) + ' · ' + esc(priceText(v)) + '</small></span>' +
        '<div class="dyo-qty" role="group" aria-label="Quantity for ' + sizeName(z) + '"><button type="button" data-q="' + z + '" data-d="-1" aria-label="Fewer"' + (off || n <= 0 ? ' disabled' : '') + '>−</button><output>' + n + '</output><button type="button" data-q="' + z + '" data-d="1" aria-label="More"' + (off || n >= max ? ' disabled' : '') + '>+</button></div></div>';
    });
    $('[data-quick]').innerHTML = html;
    var c = quickCounts();
    renderShip(c.value);
    $('[data-addquick]').textContent = c.delta < 0 ? 'Update cart' : (c.others + c.delta > 0 ? 'Add ' + (c.others + c.delta) + ' more to cart' : 'Done');
  }
  $('[data-quick]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b || b.disabled) return;
    var mat = findMat(state.mat), z = b.getAttribute('data-q');
    quick[z] = Math.min(quickMax(mat, z), Math.max(0, (quick[z] || 0) + (+b.getAttribute('data-d'))));
    renderQuick();
    var again = $('[data-q="' + z + '"][data-d="' + b.getAttribute('data-d') + '"]'); if (again && !again.disabled) again.focus();
  });

  // Modals
  var openModalEl = null, lastFocus = null;
  // A pop-up opens at its top (focusing its button does not scroll), so its heading is in view; a tall one scrolls as a whole
  function showModal(el, focusSel) { lastFocus = document.activeElement; openModalEl = el; el.hidden = false; el.scrollTop = 0; document.documentElement.style.overflow = 'hidden'; var f = el.querySelector(focusSel); if (f) f.focus({ preventScroll: true }); }
  function hideModal() { if (!openModalEl) return; openModalEl.hidden = true; openModalEl = null; document.documentElement.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  var modal = $('[data-modal]'), specModal = $('[data-specmodal]'), zoomModal = $('[data-zoommodal]');
  [modal, specModal].forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-close],[data-specclose]')) hideModal(); });
    m.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideModal(); });
  });
  // The enlarged photo closes on any click or Escape
  zoomModal.addEventListener('click', hideModal);
  zoomModal.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideModal(); });
  function openModal() { quick = {}; if (added) quick[added.z] = added.qty; renderQuick(); showModal(modal, '[data-close]'); }

  // Photo zoom: the same variant photo at 1800px
  $('[data-zoom]').addEventListener('click', function () {
    var mat = findMat(state.mat), v = variant(mat, state.size, state.btn);
    if (!v || !v.img) return;
    var big = $('[data-zoom-img]');
    big.src = v.big || v.img;
    big.alt = titleFor(mat) + ', ' + specFor(mat);
    $('[data-zoom-cap]').textContent = titleFor(mat) + ' · ' + specFor(mat);
    showModal(zoomModal, '[data-zoomclose]');
    track('zoom');
  });

  // Spec card: turn the product's spec paragraphs ("<strong>Label:</strong> value") into a label/value table,
  // drop "Also available in" (the builder already shows every option) and mark the selected size.
  function specTable(html) {
    var tmp = document.createElement('div'), rows = '';
    tmp.innerHTML = html || '';
    tmp.querySelectorAll('p').forEach(function (p) {
      var st = p.querySelector('strong'), label = '';
      if (st) { label = st.textContent.replace(/:\s*$/, '').trim(); st.parentNode.removeChild(st); }
      if (/^also available/i.test(label)) return;
      var val = p.innerHTML.replace(/^\s*:?\s*(<br\s*\/?>\s*)*/i, '').trim();
      if (/^sizes/i.test(label)) {
        var note = (label.match(/\((.*)\)/) || [])[1];
        label = 'Sizes';
        val = (note ? '<small>' + esc(note.charAt(0).toUpperCase() + note.slice(1)) + '</small>' : '') +
          val.split(/<br\s*\/?>/i).map(function (line) {
            var l = line.trim(); if (!l) return '';
            var cur = state.size === 'knob' ? /^knob/i.test(l) : l.indexOf(state.size + 'mm') === 0;
            return '<span' + (cur ? ' class="is-current"' : '') + '>' + l + '</span>';
          }).join('');
      }
      rows += '<div><dt>' + esc(label) + '</dt><dd>' + val + '</dd></div>';
    });
    return rows ? '<dl class="dyo-specs">' + rows + '</dl>' : '<p>Specifications coming soon.</p>';
  }
  $('[data-specs]').addEventListener('click', function () {
    var mat = findMat(state.mat), v = variant(mat, state.size, state.btn);
    $('[data-spec-title]').textContent = titleFor(mat);
    $('[data-spec-config]').textContent = specFor(mat) + ' · ' + priceText(v) + ' inc GST';
    var im = $('[data-spec-img]'); if (v && v.thumb) im.src = v.thumb;
    $('[data-spec-body]').innerHTML = specTable(mat.specs);
    var sh = $('[data-spec-sheet]'); if (mat.sheet) { sh.href = mat.sheet; sh.hidden = false; } else { sh.hidden = true; }
    showModal(specModal, '[data-specclose]');
    track('specs');
  });

  // Share this design
  function shareUrl() {
    var u = new URL(location.href);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'preview_theme_id'].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.set('material', state.mat); u.searchParams.set('size', state.size); u.searchParams.set('button', state.btn);
    u.searchParams.set('utm_source', 'share'); u.searchParams.set('utm_medium', 'design-your-own');
    u.searchParams.set('utm_campaign', 'shared-design'); u.searchParams.set('utm_content', design().design);
    return u.toString();
  }
  var msgTimer;
  function shareMsg(t) { var el = $('[data-sharemsg]'); el.textContent = t; clearTimeout(msgTimer); msgTimer = setTimeout(function () { el.textContent = ''; }, 4000); }
  function copyLink(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(url);
    return new Promise(function (ok, fail) {
      var ta = document.createElement('textarea'); ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? ok() : fail(); } catch (e) { fail(e); }
      document.body.removeChild(ta);
    });
  }
  $('[data-share]').addEventListener('click', function () {
    var mat = findMat(state.mat), url = shareUrl();
    var text = 'My Sloan Roberts design: ' + titleFor(mat) + ' with a ' + (mat.finishes[state.btn] || '') + ' button.';
    if (navigator.share) {
      navigator.share({ title: titleFor(mat), text: text, url: url })
        .then(function () { track('share', { method: 'share_sheet' }); shareMsg('Thanks for sharing'); })
        .catch(function () {});
      return;
    }
    copyLink(url).then(function () { track('share', { method: 'copy_link' }); shareMsg('Link copied'); })
      .catch(function () { window.prompt('Copy this link to share your design', url); track('share', { method: 'manual_copy' }); });
  });

  $('[data-add]').addEventListener('click', function () {
    var mat = findMat(state.mat), v = variant(mat, state.size, state.btn), btn = this, err = $('[data-error]');
    if (!v) return;
    var qty = state.qty;
    btn.disabled = true; btn.textContent = 'Adding…'; err.hidden = true;
    addItems([{ id: v.id, quantity: qty }]).then(function () {
      $('[data-last]').textContent = qty + ' × ' + mat.name + (HOOK ? ' hook' : '') + ' · ' + sizeName(state.size) + ' · ' + mat.finishes[state.btn] + ' button';
      $('[data-finish]').textContent = mat.name + ' with ' + mat.finishes[state.btn] + ' button. Change any quantity below and it’ll update together.';
      var inCart = 0;
      if (lastCart) lastCart.items.forEach(function (i) { if (i.variant_id === v.id) inCart += i.quantity; });
      added = { z: state.size, qty: Math.max(inCart, qty), id: v.id };
      track('add_to_cart', { quantity: qty, value: priceCents(v) * qty / 100, currency: (lastCart && lastCart.currency) || 'AUD' });
      state.qty = 1; renderPreview(); openModal();
    }).catch(function (ex) { err.textContent = ex.message; err.hidden = false; refreshCart(); });
  });

  function changeLine(variantId, delta) {
    if (!delta) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var idx = -1;
      cart.items.forEach(function (i, n) { if (idx < 0 && i.variant_id === variantId) idx = n; });
      if (idx < 0) return;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: idx + 1, quantity: Math.max(0, cart.items[idx].quantity + delta) })
      }).then(function (r) { if (!r.ok) throw new Error('Could not update your cart'); });
    });
  }

  $('[data-addquick]').addEventListener('click', function () {
    var mat = findMat(state.mat), items = [], btn = this, err = $('[data-qerror]'), c = quickCounts();
    Object.keys(quick).forEach(function (z) {
      if (added && z === added.z) return;
      var v = variant(mat, z, state.btn); if (v && quick[z] > 0) items.push({ id: v.id, quantity: quick[z] });
    });
    if (added && c.delta > 0) items.push({ id: added.id, quantity: c.delta });
    var shrink = added && c.delta < 0 ? c.delta : 0;
    if (!items.length && !shrink) { hideModal(); return; }
    btn.disabled = true; btn.textContent = 'Updating…'; err.hidden = true;
    changeLine(added && added.id, shrink)
      .then(function () { return items.length ? addItems(items) : refreshCart().then(function () { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { productId: '' } })); }); })
      .then(function () {
        track('quick_add', { pieces: c.others + c.delta, value: c.value / 100, currency: (lastCart && lastCart.currency) || 'AUD' });
        btn.disabled = false; added = null; hideModal();
      })
      .catch(function (ex) { btn.disabled = false; err.textContent = ex.message; err.hidden = false; refreshCart().then(renderQuick); });
  });

  renderAll();
  refreshCart();
  placeTop();
  if (source === 'shared') { $('[data-shared]').hidden = false; track('shared_open'); }
  track('view', { source: source });
});
